import script from "./ExpirationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpirationCard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__